import { createEl } from "./utils.js";

export default function createDropdown({ items = null, onSelect = null }) {
    let selected = null;
    const [ el, refs ] = createEl();

    const root = el("div", { class: "dropdown" }, [
        el("div", { ref: "control", class: "control" }, [
            el("div", { ref: "label", class: "label" }),
            el("div", { class: "arrow" }, [
                el("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, [
                    el("path", {
                        d: "M6 9L12 15L18 9",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                    }),
                ]),
            ]),
        ]),
        el("ul", { ref: "options", class: "options hidden" }),
    ]);

    function setOptions(newItems) {
        items = newItems;
        refs.options.innerHTML =  "";
        refs.options.append(...items.map(item => el("li", { "data-value": item.value.toString() }, item.label.toString())));
        if(items.length > 0) {
            selected = {
                label: items[0].label.toString(),
                value: items[0].value.toString(),
            };
            refs.label.textContent = selected.label;
        }
    }

    function setSelected(value) {
        for(const item of items) {
            if(item.value === value) {
                selected = {
                    label: item.label.toString(),
                    value: item.value.toString(),
                };
                refs.label.textContent = selected.label;
            }
        }
    }

    document.addEventListener("click", (event) => {
        if(!root.contains(event.target)) {
            refs.options.classList.add("hidden");
        }
    });

    refs.control.addEventListener("click", (event) => {
        event.preventDefault();
        refs.options.classList.toggle("hidden");
    });

    refs.options.addEventListener("click", (event) => {
        if(event.target.dataset.value) {
            selected = {
                label: event.target.textContent,
                value: event.target.dataset.value,
            };

            refs.label.textContent = selected.label;
            refs.options.classList.add("hidden");

            if(typeof onSelect === "function") {
                onSelect(selected);
            }
        }
    });

    if(items !== null) {
        setOptions(items);
    }

    return {
        root,
        setOptions,
        setSelected,
        get selected() {
            return selected;
        }
    };
}
